import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import SelectGeneric from "../../../components/select/selectGeneric";

// components
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import TranslateButton from "../../../components/buttons/TranslateButton";

// labels
import {REQUIRED, LB_PROJECT} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {translateCountService} from "../../../jwt/_services/xooka/translateCountService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {fbProjectProvider} from "../../../providers/fbProjectProvider";



const TranslateCountForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const [project, setProject] = useState(domainObject?.project || true);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        monthlyCharacters: Yup.number().required( REQUIRED ),
        charactersToTranslate: Yup.number().required( REQUIRED ),
        translatedCharacter: Yup.number().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            monthlyCharacters: domainObject?.monthlyCharacters,
            charactersToTranslate: domainObject?.charactersToTranslate,
            translatedCharacter: domainObject?.translatedCharacter,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
            }
        };

        if(project !== undefined && project !== null)
            dataRequest.item.project = project;

        if (!editMode)
            genericIndexedActions.save(path, translateCountService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, translateCountService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={translateCountService} />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <FormGroup>
                            <SelectGeneric
                                title={LB_PROJECT}
                                initialValue={project}
                                setExternalValue={setProject}
                                provider={fbProjectProvider}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Caracteres por mes</Label>
                            <Input
                                type="number"
                                name="monthlyCharacters"
                                placeholder={'Caracteres por mes'}
                                innerRef={register}
                            />
                            { errors.monthlyCharacters && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.monthlyCharacters?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>Caracteres traducidos:</Label>
                            <Input
                                type="number"
                                name="translatedCharacter"
                                placeholder={'Caracteres traducidos'}
                                innerRef={register}
                            />
                            { errors.translatedCharacter && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.translatedCharacter?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>Caracteres disponibles:</Label>
                            <Input
                                type="number"
                                name="charactersToTranslate"
                                placeholder={'Caracteres disponibles'}
                                innerRef={register}
                            />
                            { errors.charactersToTranslate && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.charactersToTranslate?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default TranslateCountForm